import React from 'react';

const InformationMissing = () => {
	return (
		<span className="information-missing">--</span>
	);
}

export default InformationMissing;